'use client'
import { useTranslations } from 'next-intl'
import React, { useEffect, useRef, useState } from 'react'
import { ChevronCircleDown } from './Icons'
import { cx } from '@monorepo/helper/cx'
import { SUBMENU_SCROLL_PADDING } from '@/app/[locale]/[year]/SubMenu'

const ScrollDownButton = () => {
  const [show, setShow] = useState(true)
  const t = useTranslations('common')
  const buttonRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    const handleScroll = () => {
      const position = window.scrollY
      setShow(position < 100)
    }
    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const click = () => {
    const top = buttonRef.current?.parentElement?.getBoundingClientRect().bottom

    window.scrollTo({
      top: top ? top - SUBMENU_SCROLL_PADDING : undefined,
      behavior: 'smooth',
    })
  }

  return (
    <div
      className={cx(
        'pointer-events-none fixed bottom-0 left-0 z-50 w-full transform pt-12 transition-all duration-150 ease-in-out',
        show ? 'opacity-100' : 'opacity-0',
      )}
      style={{
        background:
          'linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(0,0,0,0.8) 100%)',
      }}
    >
      <button
        onClick={click}
        ref={buttonRef}
        className={cx(
          'pointer-events-auto relative left-1/2 mb-24 -translate-x-1/2 cursor-pointer text-center uppercase tracking-wider text-white duration-150 ease-in-out focus:outline-none sm:text-lg lg:mb-5',
          show ? 'pointer-events-all' : 'pointer-events-none translate-y-8',
        )}
      >
        {t('scrollDown')}
        <br />
        <ChevronCircleDown className="mt-1 inline-block w-5 fill-current text-sm text-white" />
      </button>
    </div>
  )
}

export default ScrollDownButton
